import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdvertiserLogin } from '../../hooks/useAdvertiserAuth';

export default function AdvertiserLoginPage() {
  const navigate = useNavigate();
  const { login, isPending } = useAdvertiserLogin();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await login(email, password);
      navigate('/ads');
    } catch (err) {
      setError(err.message || 'Login failed.');
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <form onSubmit={handleSubmit} className="w-full max-w-sm bg-white rounded-2xl border border-slate-200 p-6 space-y-4">
        <h1 className="text-lg font-black text-slate-900 text-center">Advertiser Log In</h1>

        <input
          type="email"
          required
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm"
        />
        <input
          type="password"
          required
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm"
        />

        {error && <p className="text-xs text-red-600 font-bold text-center">{error}</p>}

        <button
          type="submit"
          disabled={isPending}
          className="w-full py-3.5 rounded-xl font-black text-sm uppercase tracking-widest text-white bg-slate-900 disabled:opacity-40"
        >
          {isPending ? 'Logging in...' : 'Log In'}
        </button>

        <p className="text-center text-xs text-slate-400">
          No account yet?{' '}
          <button type="button" onClick={() => navigate('/ads/apply')} className="font-bold text-slate-700 underline">
            Apply here
          </button>
        </p>
      </form>
    </div>
  );
}